/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

.acronym-header {
  grid-area: acronyms;
  display: flex;
  place-items: center;
  gap: variables.$padding-small;

  #acronym-menu-button {
    width: variables.$sidebar-width;
    height: variables.$searchbar-height;
    justify-content: space-around;
    font-size: 15px;
    background-color: variables.$area-background-color;
    color: #0f0f0f;
    border-color: variables.$background-color-primary;
  }
}

.MuiMenu-paper {
  min-width: variables.$sidebar-width;
}
